// extracted by mini-css-extract-plugin
export default {"shadow-icon":"TimeTrackingWidgetAction_shadow-icon__wloR8"};